import React, { ReactElement, useEffect, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";
import { useCallCampaignContext } from "@hooks/useCallCampaignContext";
interface RecaptchaResponse {
    data: {
        success: boolean;
    };
}
export default function CallsCampaignRecaptcha(): ReactElement {
    const recaptchaRef = useRef<ReCAPTCHA>(null);
    const { updateShowPhoneNumber } = useCallCampaignContext();
    const onChange = (token: string) => {
        if (token) {
            axios
                .post("/api/recaptcha", { token })
                .then((success: RecaptchaResponse) => {
                    if (success.data?.success) {
                        updateShowPhoneNumber(true);
                    } else {
                        updateShowPhoneNumber(false);
                    }
                })
                .catch(() => {
                    updateShowPhoneNumber(false);
                });
        } else {
            updateShowPhoneNumber(false);
        }
    };
    const onExpired = () => {
        recaptchaRef.current?.reset();
    };

    useEffect(() => {
        // if (visitDetails?.trafficSourceNetwork === "bing") {
        if (recaptchaRef) {
            recaptchaRef.current?.execute();
        }

        // }
    }, []);

    return (
        <ReCAPTCHA
            sitekey={`${
                process.env
                    .NEXT_PUBLIC_GOOGLE_INVISIBLE_RECAPTCHA_SITE_KEY_CLIENT as string
            }`}
            onChange={onChange}
            onExpired={onExpired}
            size="invisible"
            ref={recaptchaRef}
        />
    );
}
